import * as AppConstants from "AppConstants";

/**
 * Substitutes placeholder and returns 
 * 
 * Declare constant for endpoint in AppConstants with placeholders for PathVariables and RequestParams if any
 * 
 * This module has functions which replaces placeholders by actual values and provide activities endpoints
 * 
 * Invoked in functions where call to the respective activities endpoint is to be made
 * 
 * @param type 
 * 
 * @param param1 
 */


/**
 * Replaces clientId placeholder with actual client id value
 * @returns members for client URL to be fired  - 
 * GET /v1/api/clients/{clientId}/members
 * Example output to return: http://localhost:8081/v1/api/clients/100/members
 * */
export const getUrlForAllMembersForClient = (clientId) => {
    const url = AppConstants.GET_MEMBERS_FOR_CLIENT_ENDPOINT
                    .replace(AppConstants.CLIENT_ID_PLACEHOLDER, clientId);
    return url;
};

export const getUrlForLoadAllLocationsFromBackend = () => {
    const url = AppConstants.GET_LOCATIONS_ENDPOINT;
    return url;
};

export const getUrlForLoadAllWorkingHoursByClientFromBackend = (clientId) => {
    const url = AppConstants.GET_WORKING_HOURS_BY_CLIENT_ENDPOINT.replace(AppConstants.CLIENT_ID_PLACEHOLDER, clientId);
    return url;
};

export const getUrlToCreateWorkingHour = () => {
    const url = AppConstants.CREATE_WORKING_HOURS_ENDPOINT;
    return url;
};

export const getUrlToUpdateWorkingHour = (id) => {
    const url = AppConstants.UPDATE_WORKING_HOURS_ENDPOINT
                .replace(AppConstants.WORKING_HOUR_ID_PLACEHOLDER, id);
    return url;
};

export const getUrlToDeleteWorkingHour = (id) => {
    const url = AppConstants.DELETE_WORKING_HOURS_ENDPOINT
                .replace(AppConstants.WORKING_HOUR_ID_PLACEHOLDER, id);
    return url;
};

/**
 * Replaces clientId placeholder with actual client id value
 * @returns members for client URL to be fired  - 
 * GET /v1/api/clients/{clientId}/members
 * Example output to return: http://localhost:8081/v1/api/clients/100/members
 * */
 export const getUrlForAllMembersForAllClients = () => {
    const url = AppConstants.GET_MEMBERS_FOR_CLIENTS_ENDPOINT
    return url;
};


/**
 * Replaces userId placeholder with actual user id value
 * @returns client URL to be fired
 * GET /v1/api/clients/byuser/{userId}
 * Example output to return: http://localhost:8081/v1/api/clients/byuser/1
 * */
 export const getUrlForClientByClientUserId = (userId) => {
    const url = AppConstants.GET_CLIENT_BY_CLIENT_USER_ID_ENDPOINT
                    .replace(AppConstants.USER_ID_PLACEHOLDER, userId);
    return url;
};

/**
 * Replaces userId placeholder with actual user id value
 * @returns client URL to be fired
 * GET /v1/api/clients/byMemberUser/{memberUserId}
 * Example output to return: http://localhost:8081/v1/api/clients/byMemberUser/1
 * */
 export const getUrlForClientByMemberUserId = (memberUserId) => {
    const url = AppConstants.GET_CLIENT_BY_MEMBER_USER_ID_ENDPOINT
                    .replace(AppConstants.USER_ID_PLACEHOLDER, memberUserId);
    return url;
};

/**
 * @returns client URL to be fired
 * GET /v1/api/clients/all
 * Example output to return: http://localhost:8081/v1/api/clients/all
 * */
 export const getUrlForAllClients = () => {
    const url = AppConstants.GET_ALL_CLIENTS_ENDPOINT;
    return url;
};

/**
 * Builds the server-paginated clients URL with page/sort/search query params.
 * GET /v1/api/clients/all/paged?pageNumber=&pageSize=&sortBy=&sortDirection=&searchQuery=
 */
export const getUrlForClientsPage = ({ page, pageSize, sortBy, sortDirection, searchQuery }) => {
    const params = new URLSearchParams({
        pageNumber: String(page ?? 0),
        pageSize: String(pageSize ?? 10),
        sortBy: sortBy ?? "name",
        sortDirection: sortDirection ?? "ASC",
    });
    if (searchQuery) params.append("searchQuery", searchQuery);
    return `${AppConstants.GET_CLIENTS_PAGED_ENDPOINT}?${params.toString()}`;
};

export const getUrlToCreateClient = () => {
    const url = AppConstants.CREATE_CLIENT_ENDPOINT;
    return url;
};

 export const getUrlToUpdateClient = (client_id) => {
    const url = AppConstants.UPDATE_CLIENT_ENDPOINT
                .replace(AppConstants.CLIENT_ID_PLACEHOLDER, client_id);
    return url;
};

 export const getUrlToDeleteClient = (client_id) => {
    const url = AppConstants.DELETE_CLIENT_ENDPOINT
                .replace(AppConstants.CLIENT_ID_PLACEHOLDER, client_id);
    return url;
};


export const getUrlForAllClientMappings = () => {
    const url = AppConstants.GET_CLIENT_MAPPING_ENDPOINT;
    return url;
 };

/**
 * Builds the server-paginated client-user mappings URL with page/sort/search query params.
 * User name/email are enriched from user-auth after fetch, so the server resolves search by
 * enriching-then-filtering rather than a DB query, but the client contract is the same.
 * GET /v1/api/clients/users/all/paged?pageNumber=&pageSize=&sortBy=&sortDirection=&searchQuery=
 */
export const getUrlForClientMappingsPage = ({ page, pageSize, sortBy, sortDirection, searchQuery }) => {
    const params = new URLSearchParams({
        pageNumber: String(page ?? 0),
        pageSize: String(pageSize ?? 10),
        sortBy: sortBy ?? "id",
        sortDirection: sortDirection ?? "ASC",
    });
    if (searchQuery) params.append("searchQuery", searchQuery);
    return `${AppConstants.GET_CLIENT_MAPPING_PAGED_ENDPOINT}?${params.toString()}`;
 };

export const getUrlToCreateClientMapping = () => {
    const url = AppConstants.CREATE_CLIENT_MAPPING_ENDPOINT;
    return url;
 };
 
 export const getUrlToUpdateClientMapping = (member_id) => {
    const url = AppConstants.UPDATE_CLIENT_MAPPING_ENDPOINT
        .replace(AppConstants.MEMBER_ID_PLACEHOLDER, member_id);
    return url;
 };
 
 export const getUrlToDeleteClientMapping = (deleteObj) => {
    const url = AppConstants.DELETE_CLIENT_MAPPING_ENDPOINT
        .replace(AppConstants.USER_ID_PLACEHOLDER, deleteObj.userId)
        .replace(AppConstants.CLIENT_ID_PLACEHOLDER, deleteObj.clientId);
    return url;
 };

// ---------------------------------------------------------------------------
// BDM (Business Development Manager) to client mapping — @since NEXT_VERSION (HRMS-116)
// ---------------------------------------------------------------------------

export const getUrlForClientsForBdm = (bdmUserId) => {
    return AppConstants.GET_CLIENTS_FOR_BDM_ENDPOINT
        .replace(AppConstants.USER_ID_PLACEHOLDER, bdmUserId);
};